<style scope>

</style>

<template>
    <van-tabbar v-model="active" @change="activeMenu">
        <van-tabbar-item icon="todo-list-o" :info="info">待办</van-tabbar-item>
        <van-tabbar-item icon="home-o" v-show="dateViewRole">报表</van-tabbar-item>
        <van-tabbar-item icon="search">监控</van-tabbar-item>
        <van-tabbar-item icon="setting-o">设置</van-tabbar-item>
    </van-tabbar>
</template>

<script type="text/ecmascript-6">
    import { eventBus } from '../../vue/utils/eventBus'
    import { mapGetters } from 'vuex'
    import store from '@/vue/store'
    import Vue from 'vue'
    export default {
        name: 'tabBar',
        props: {},
        computed: mapGetters([
            'roles'
        ]),
        watch: {

        },
        data: function () {
            return {
                //active: 0,
                info: '',
                active: 0,
                dateViewRole: false
            }
        },
        methods: {
            activeMenu(index) {
                this.active = index
                store.commit('SET_ACTIVE', index)
                if (index === 0) {
                    this.$router.push({path: '/home'})
                } else if (index === 1) {
                    this.$router.push({path: '/report'})
                }else if (index === 2) {
                    this.$router.push({path: '/monitoring'})
                }else if (index === 3) {
                    this.$router.push({path: '/setting'})
                }
            }
        },
        mounted() {
            let self = this
            eventBus.$on('tabbarInfo', function (num) {
                self.info = num == '0' ? '' : num
            })
            this.active = Vue.ls.get('MENU_ACTIVE')
            this.roles.forEach(item=>{
                if(item === 'DATA_VIEW'){
                    self.dateViewRole = true
                }
            })
        },
        destroyed() {
            eventBus.$off('tabbarInfo')
        }
    }
</script>
